var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appointment 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.25 11V19.25H5.5V11C5.5 9.4875 6.7375 8.25 8.25 8.25H71.5C73.0125 8.25 74.25 9.4875 74.25 11Z",
    fill: "url(#paint0_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.25 19.25V74.25C74.25 75.7625 73.0125 77 71.5 77H8.25C6.7375 77 5.5 75.7625 5.5 74.25V19.25H74.25Z",
    fill: "url(#paint1_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.875 12.375C39.1187 12.375 38.5 11.7562 38.5 11V5.5C38.5 4.74375 39.1187 4.125 39.875 4.125C40.6312 4.125 41.25 4.74375 41.25 5.5V11C41.25 11.7562 40.6312 12.375 39.875 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.5 12.375C26.7437 12.375 26.125 11.7562 26.125 11V5.5C26.125 4.74375 26.7437 4.125 27.5 4.125C28.2562 4.125 28.875 4.74375 28.875 5.5V11C28.875 11.7562 28.2562 12.375 27.5 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.125 12.375C14.3687 12.375 13.75 11.7562 13.75 11V5.5C13.75 4.74375 14.3687 4.125 15.125 4.125C15.8812 4.125 16.5 4.74375 16.5 5.5V11C16.5 11.7562 15.8812 12.375 15.125 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.25 12.375C51.4937 12.375 50.875 11.7562 50.875 11V5.5C50.875 4.74375 51.4937 4.125 52.25 4.125C53.0062 4.125 53.625 4.74375 53.625 5.5V11C53.625 11.7562 53.0062 12.375 52.25 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M64.625 12.375C63.8687 12.375 63.25 11.7562 63.25 11V5.5C63.25 4.74375 63.8687 4.125 64.625 4.125C65.3812 4.125 66 4.74375 66 5.5V11C66 11.7562 65.3812 12.375 64.625 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.875 27.5H12.375C11.6156 27.5 11 28.1156 11 28.875V34.375C11 35.1344 11.6156 35.75 12.375 35.75H17.875C18.6344 35.75 19.25 35.1344 19.25 34.375V28.875C19.25 28.1156 18.6344 27.5 17.875 27.5Z",
    fill: "url(#paint2_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.375 27.5H28.875C28.1156 27.5 27.5 28.1156 27.5 28.875V34.375C27.5 35.1344 28.1156 35.75 28.875 35.75H34.375C35.1344 35.75 35.75 35.1344 35.75 34.375V28.875C35.75 28.1156 35.1344 27.5 34.375 27.5Z",
    fill: "url(#paint3_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M50.875 27.5H45.375C44.6156 27.5 44 28.1156 44 28.875V34.375C44 35.1344 44.6156 35.75 45.375 35.75H50.875C51.6344 35.75 52.25 35.1344 52.25 34.375V28.875C52.25 28.1156 51.6344 27.5 50.875 27.5Z",
    fill: "url(#paint4_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M67.375 27.5H61.875C61.1156 27.5 60.5 28.1156 60.5 28.875V34.375C60.5 35.1344 61.1156 35.75 61.875 35.75H67.375C68.1344 35.75 68.75 35.1344 68.75 34.375V28.875C68.75 28.1156 68.1344 27.5 67.375 27.5Z",
    fill: "url(#paint5_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.875 44H12.375C11.6156 44 11 44.6156 11 45.375V50.875C11 51.6344 11.6156 52.25 12.375 52.25H17.875C18.6344 52.25 19.25 51.6344 19.25 50.875V45.375C19.25 44.6156 18.6344 44 17.875 44Z",
    fill: "url(#paint6_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.375 44H28.875C28.1156 44 27.5 44.6156 27.5 45.375V50.875C27.5 51.6344 28.1156 52.25 28.875 52.25H34.375C35.1344 52.25 35.75 51.6344 35.75 50.875V45.375C35.75 44.6156 35.1344 44 34.375 44Z",
    fill: "url(#paint7_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M50.875 44H45.375C44.6156 44 44 44.6156 44 45.375V50.875C44 51.6344 44.6156 52.25 45.375 52.25H50.875C51.6344 52.25 52.25 51.6344 52.25 50.875V45.375C52.25 44.6156 51.6344 44 50.875 44Z",
    fill: "url(#paint8_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M67.375 44H61.875C61.1156 44 60.5 44.6156 60.5 45.375V50.875C60.5 51.6344 61.1156 52.25 61.875 52.25H67.375C68.1344 52.25 68.75 51.6344 68.75 50.875V45.375C68.75 44.6156 68.1344 44 67.375 44Z",
    fill: "url(#paint9_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M17.875 60.5H12.375C11.6156 60.5 11 61.1156 11 61.875V67.375C11 68.1344 11.6156 68.75 12.375 68.75H17.875C18.6344 68.75 19.25 68.1344 19.25 67.375V61.875C19.25 61.1156 18.6344 60.5 17.875 60.5Z",
    fill: "url(#paint10_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M34.375 60.5H28.875C28.1156 60.5 27.5 61.1156 27.5 61.875V67.375C27.5 68.1344 28.1156 68.75 28.875 68.75H34.375C35.1344 68.75 35.75 68.1344 35.75 67.375V61.875C35.75 61.1156 35.1344 60.5 34.375 60.5Z",
    fill: "url(#paint11_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M50.875 60.5H45.375C44.6156 60.5 44 61.1156 44 61.875V67.375C44 68.1344 44.6156 68.75 45.375 68.75H50.875C51.6344 68.75 52.25 68.1344 52.25 67.375V61.875C52.25 61.1156 51.6344 60.5 50.875 60.5Z",
    fill: "url(#paint12_linear_9643_24316)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M70.125 82.5C76.9595 82.5 82.5 76.9595 82.5 70.125C82.5 63.2905 76.9595 57.75 70.125 57.75C63.2905 57.75 57.75 63.2905 57.75 70.125C57.75 76.9595 63.2905 82.5 70.125 82.5Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M71.0843 77.981C70.8315 78.2338 70.4912 78.3797 70.112 78.3894C69.3536 78.3894 68.7411 77.7769 68.7411 77.0185V63.2706C68.7411 62.5122 69.3536 61.8997 70.112 61.8997C70.8704 61.8997 71.4829 62.5122 71.4829 63.2706V77.0185C71.4829 77.4074 71.3273 77.738 71.0745 77.9908L71.0843 77.981Z",
    fill: "url(#paint13_linear_9643_24316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M77.969 71.0954C77.7162 71.3482 77.3759 71.494 76.9967 71.5037L63.2488 71.5037C62.4904 71.5037 61.8779 70.8912 61.8779 70.1328C61.8779 69.3744 62.4904 68.7619 63.2488 68.7619L76.9967 68.7619C77.7551 68.7619 78.3676 69.3744 78.3676 70.1328C78.3676 70.5217 78.212 70.8523 77.9592 71.1051L77.969 71.0954Z",
    fill: "url(#paint14_linear_9643_24316)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9643_24316",
    x1: 19.5018,
    y1: 8.16609,
    x2: 19.6284,
    y2: 19.2102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9643_24316",
    x1: 5.50117,
    y1: 48.125,
    x2: 74.2504,
    y2: 48.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9643_24316",
    x1: 12.6802,
    y1: 27.4371,
    x2: 13.2707,
    y2: 35.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9643_24316",
    x1: 29.1802,
    y1: 27.4371,
    x2: 29.7707,
    y2: 35.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9643_24316",
    x1: 45.6802,
    y1: 27.4371,
    x2: 46.2707,
    y2: 35.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9643_24316",
    x1: 62.1802,
    y1: 27.4371,
    x2: 62.7707,
    y2: 35.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9643_24316",
    x1: 12.6802,
    y1: 43.9371,
    x2: 13.2707,
    y2: 52.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9643_24316",
    x1: 29.1802,
    y1: 43.9371,
    x2: 29.7707,
    y2: 52.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9643_24316",
    x1: 45.6802,
    y1: 43.9371,
    x2: 46.2707,
    y2: 52.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9643_24316",
    x1: 62.1802,
    y1: 43.9371,
    x2: 62.7707,
    y2: 52.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9643_24316",
    x1: 12.6802,
    y1: 60.4371,
    x2: 13.2707,
    y2: 68.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9643_24316",
    x1: 29.1802,
    y1: 60.4371,
    x2: 29.7707,
    y2: 68.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9643_24316",
    x1: 45.6802,
    y1: 60.4371,
    x2: 46.2707,
    y2: 68.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9643_24316",
    x1: 63.0261,
    y1: 68.2823,
    x2: 72.4592,
    y2: 76.4544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9643_24316",
    x1: 63.0369,
    y1: 68.2706,
    x2: 72.4699,
    y2: 76.4427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCalendar);
export default __webpack_public_path__ + "static/media/noCalendar.f632be828b3c2cae9bd0af6f7e52caab.svg";
export { ForwardRef as ReactComponent };